import { StandardSupportButtons } from '../StandardSupportButtons';
import { PromoteGiveForActivityList } from '../../number-of-recent-transactions/PromoteGiveForActivityList';
import { CartSupportButtons } from '../CartSupportButtons';
import { useCart } from '../../../project-hooks/useCart';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSubproject } from '../../../../components/hooks/useSubproject';
import { useProject } from '../../../project-hooks/useProject';
import { useLocation, useNavigate } from 'react-router';
import { useHasFetchedFeatures } from '../../../../components/hooks/isFeatureEnabled';
import { getPublishedRewardsForProject } from '../../../projects-reducer';
import { useProjectABCTest } from '../../../../components/hooks/projectAbcTest';
import { getPropertiesForProjectABCTest, trackEvent } from '../../../../support-and-tracking/analytics-actions';
import { useMoveIntercomAway } from '../../../../support-and-tracking/intercom-hooks';
import { getSupportLink } from '../../../project-model';
import { getSearchParamsUrlFromObject } from '../../../../utils';
import styles from './ProjectSupportButtonsActive.module.less';

export const ProjectSupportButtonsActive = ({ className, projectShareModalRef, promoteActivity }) => {
    const { sum: cartSum, count: cartCount } = useCart();
    const supportButtons = useRef(null);
    const productCategoryModalOpen = useSelector((state) => state.productCategoryModal.isOpen);

    const [isFixed, setIsFixed] = useState(false);
    const { subproject, subprojectId } = useSubproject();
    const project = useProject();
    const navigate = useNavigate();
    const location = useLocation();
    const hasFetchedFeatures = useHasFetchedFeatures();
    const hideOnMobileWhenModalIsOpen = isFixed && productCategoryModalOpen;
    const publishedRewards = useSelector((state) => getPublishedRewardsForProject(state, project.id));
    const paymentForm = useSelector((state) => state.paymentForm);

    const abcTest = useProjectABCTest({ project });

    useEffect(() => {
        if (supportButtons?.current) {
            const isFixed = supportButtons?.current && getComputedStyle(supportButtons?.current).position === 'fixed';
            setIsFixed(isFixed);
        }
    }, [supportButtons]);

    const sharePressed = () => {
        trackEvent('project', 'share', {
            channel: 'modal',
            'project-id': project.id,
            location: 'banner',
            ...getExtraTrackingParameters(),
        });
        projectShareModalRef?.current?.open();
    };

    const getExtraTrackingParameters = () => ({
        ...getPropertiesForProjectABCTest({ variant: abcTest.variant, eligible: abcTest.eligible }),
    });

    useMoveIntercomAway();

    const navigateToPayment = () => {
        const currentPathname = location?.pathname;
        const supportLink = getSupportLink({
            projectId: project.id,
            rewards: publishedRewards,
            currentPathname,
            project,
            subprojectId,
        });
        const search = getSearchParamsUrlFromObject({ subproject: subproject?.id, amount: paymentForm?.amount }, true);
        navigate({
            pathname: supportLink,
            search,
        });
    };

    const navigateToCart = () => {
        const search = getSearchParamsUrlFromObject({ subproject: subproject?.id }, true);
        navigate({
            pathname: `/project/${project.id}/payment`,
            search,
        });
    };

    return (
        <div
            className={[
                styles.supportButtonsWrapperProjectIsActive,
                hideOnMobileWhenModalIsOpen || !hasFetchedFeatures ? styles.hiddenOnMobile : '',
                className,
            ].join(' ')}
            ref={supportButtons}
        >
            <div className={styles.supportButtons}>
                {cartSum ? (
                    <CartSupportButtons cartSum={cartSum} cartCount={cartCount} navigateToCart={navigateToCart} />
                ) : promoteActivity ? (
                    <div className={styles.standardSupportButtons}>
                        <PromoteGiveForActivityList />
                        <StandardSupportButtons
                            project={project}
                            navigateToPayment={navigateToPayment}
                            wrapperClass={styles.buttonGroupWrapperPromoteActivity}
                            showShare={false}
                            showNumberOfRecentTransactions={false}
                        />
                    </div>
                ) : (
                    <div className={styles.standardSupportButtons}>
                        <StandardSupportButtons
                            project={project}
                            navigateToPayment={navigateToPayment}
                            sharePressed={sharePressed}
                            wrapperClass={styles.buttonGroupWrapperStandard}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
